import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {delay, tap} from 'rxjs/operators';
import {Globals} from '../../global/globals';
import {Router} from '@angular/router';
import {Dashboard} from "../../dtos/dashboard/Dashboard";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private baseUri: string = this.globals.backendUri + '/dashboard';

  constructor(private httpClient: HttpClient, private globals: Globals, private router: Router) {
  }

  /**
   * get the current dashboard overview
   */
  getDashboard(): Observable<Dashboard> {
    console.log('Get the current dashboard overview');
    return this.httpClient.get<Dashboard>(this.baseUri)
      .pipe(delay(0))
      .pipe(tap(resp => {
        return resp;
      }));
  }

}
